import React, { useState } from 'react';
import cn from 'classnames';

import CardContainer from '../../../Components/Card/CardContainer';
import CardHeader from '../../../Components/Card/CardHeader';
import CardBody from '../../../Components/Card/CardBody';
import Input from '../../../Components/Input/Input';
import Button from '../../../Components/Button/Button';
import HomesBoard from './Board/HomesBoard';

import chevron from '../../../icons/chevron.svg';
import styles from './homes.module.css';

const Homes = ({ home, complex }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [isOpenBoard, setIsOpenBoard] = useState(false);

  const [building, setBuilding] = useState({
    number: null,
    address: null,
    area: null,
    floor: null, // общее количество квартир
    apartments: null, // подьезды
    doors: null, // квартир на этаже
    entrance: null, // этажи
    parking: null,
    pantry: null,
    homes: null
  });

  const createHomes = (apartments, entrances, floors, doorsPerFloor) => {
    return Array.from({ length: apartments }, (_, apartment) => {
      const entrance = Math.floor(apartment / (floors * doorsPerFloor)) + 1;
      const floor = Math.floor((apartment % (floors * doorsPerFloor)) / doorsPerFloor) + 1;
      const door = (apartment % doorsPerFloor) + 1;
      const apartmentNumber = apartment + 1;

      return {
        apartmentNumber,
        entrance,
        floor,
        door
      };
    });
  };

  return (
    <div className={styles.corpus}>
      <CardContainer>
        <CardHeader
          menu
          chevron={
            <div className={styles.chevron}>
              <img width='13px' height='13px' className={cn(styles.up, { [styles.down]: isOpen })} src={chevron}/>
              <img width='13px' height='13px' className={cn(styles.up, { [styles.down]: !isOpen })} src={chevron}/>
            </div>
          }
          title={`Дом ${home}`}
        />
        <div className={cn(styles.close, {[styles.open]: isOpen})}>
          <CardBody>
            <div className={styles.wrapper}>
              <Input
                label="Кадастровый номер дома"
                disabled={isOpenBoard}
                onChange={(value) => setBuilding({
                  ...building,
                  number: value
                })}
                value={building?.number}
              />
              <Input
                name="address"
                label="Адрес по кадастру"
                disabled={isOpenBoard}
                onChange={(value) => setBuilding({
                  ...building,
                  address: value
                })}
                value={building?.address}
              />
              <Input
                label="Площадь по кадастру"
                disabled={isOpenBoard}
                onChange={(value) => setBuilding({
                  ...building,
                  area: value
                })}
                value={building?.area}
              />
            </div>
            <div className={styles.wrapper}>
              <Input
                label="Количество помещений"
                onChange={(value) => setBuilding({
                  ...building,
                  floor: value
                })}
                value={building?.floor}
                disabled={isOpenBoard}
              />
              <Input
                label="Количество подьездов"
                onChange={(value) => setBuilding({
                  ...building,
                  apartments: value
                })}
                value={building?.apartments}
                disabled={isOpenBoard}
              />
              <Input
                label="Количество этажей"
                onChange={(value) => setBuilding({
                  ...building,
                  entrance: value
                })}
                value={building?.entrance}
                disabled={isOpenBoard}
              />
            </div>
            <div className={ styles.wrapper }>
              <Input
                label="Количество квартир на этаже"
                onChange={(value) => setBuilding({
                  ...building,
                  doors: value
                })}
                value={building?.doors}
                disabled={isOpenBoard}
              />
              <Input
                label="Количество машиномест"
                onChange={(value) => setBuilding({
                  ...building,
                  parking: value
                })}
                value={building?.parking}
                disabled={isOpenBoard}
              />
              <Input
                label="Количество кладовых"
                onChange={(value) => setBuilding({
                  ...building,
                  pantry: value
                })}
                value={building?.pantry}
                disabled={isOpenBoard}
              />
            </div>
            <div className={ styles.wrapper }>
              <Input
                label="Коммерческие помещения"
                onChange={(value) => setBuilding({
                  ...building,
                  commerce: value
                })}
                value={building?.commerce}
                disabled={isOpenBoard}
              />
              <Input
                label="Технические помещения"
                onChange={(value) => setBuilding({
                  ...building,
                  utility: value
                })}
                value={building?.utility}
                disabled={isOpenBoard}
              />
            </div>
          </CardBody>
          <CardHeader
            title="Помещения"
            menu
            button={
              <Button
                isDisabled={!building?.entrance || !building?.apartments || !building?.doors}
                type='default'
                text={ isOpenBoard? 'Редактировать' : 'Создать шахматку' }
                onClick={() => {
                  const newHomes = createHomes(
                    building.apartments * building.entrance * building.doors,
                    building.apartments,
                    building.entrance,
                    building.doors
                  );
                  setIsOpenBoard(!isOpenBoard);
                  setBuilding({
                    ...building,
                    floor: building.apartments * building.entrance * building.doors,
                    homes: newHomes
                  })
                }}
              />
            }
          />
          <div className={cn(styles.close, {[styles.open]: isOpenBoard})}>
            <CardBody>
              <HomesBoard subject={complex?.UlSubject?.code} building={building}/>
            </CardBody>
          </div>
        </div>
        <div className={styles.footer}>
          <div className={styles.buttons}>
            <Button
              onClick={() => setIsOpen(!isOpen)}
              type='default'
              text={ isOpen ? 'Отменить' : 'Редактировать' }
            />
            <Button
              isDisabled={!isOpen || !isOpenBoard}
              onClick={() => setIsOpen(!isOpen)}
              type='purple'
              text='Сохранить'
            />
          </div>
        </div>
      </CardContainer>
    </div>
  );
};

export default Homes;
